import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route wrapper that requires Super Admin role.
 * Redirects Club Admins to the dashboard.
 */
export const SuperAdminRoute = ({ children }) => {
  const { isSuperAdmin, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!isSuperAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};
